import classNames from 'classnames'
import React from 'react'

import { SIDEBAR_CONTENT_WIDTH, SIDEBAR_SECTIONS_WIDTH } from '../../../../css/LayoutVariables'
import OnboardTooltip from '../../../components/onboard-tooltip'
import { useNavigationContext } from '../../../contexts/NavigationContext'
import { useEventFeedsContext } from '../context'

import './styles.scss'

const EventFeedsVizualizationOnboardTooltips = ({ className, panelWidth, onFinish }) => {
  const { sidebarRetracted } = useNavigationContext()

  const { id } = useEventFeedsContext()
  const numberOfSteps = id === 'discovery' ? 8 : 9

  return (
    <div
      className={classNames('event-feeds-visualization-onboard-tooltip__container', className)}
      style={{
        left: SIDEBAR_SECTIONS_WIDTH + panelWidth + (!sidebarRetracted ? SIDEBAR_CONTENT_WIDTH : 0),
      }}
    >
      <div
        className="event-feeds-visualization-onboard-tooltip__backdrop"
        style={{
          left: 0,
          width:
            SIDEBAR_SECTIONS_WIDTH + panelWidth + (!sidebarRetracted ? SIDEBAR_CONTENT_WIDTH : 0),
        }}
      />

      <OnboardTooltip
        contentClassName="event-feeds-visualization-onboard-tooltip__tooltip-filters"
        arrowDirection="top"
        step={5}
        numberOfSteps={numberOfSteps}
        left={-15}
        top={50}
        title="Visual tabs"
        description="Explore each visualization tab to see how your configured data look like."
        onNextClick={() => {
          onFinish(true)
        }}
        onClose={() => onFinish(false)}
      />
    </div>
  )
}

export default EventFeedsVizualizationOnboardTooltips
